import React, { useState } from "react";
import FirstTab from "./FirstTab";
import SecondTab from "./SecondTab";

function Tabs(props) {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTab1 = () => {
    setActiveTab("tab1");
  };

  const handleTab2 = () => {
    setActiveTab("tab2");
  };

  return (
    <div className="Tabs">
      <ul className="nav">
        <li
          className={activeTab === "tab1" ? "active" : ""}
          onClick={handleTab1}
        >
          <a href = "#">
          Painel
          </a>
        </li>
        <li
          className={activeTab === "tab2" ? "active" : ""}
          onClick={handleTab2}
        >
          <a href = "#">
          Dados do Painel
          </a>
        </li>
      </ul>
      <div className="outlet">
        {activeTab === "tab1" ? <FirstTab dashboard_id={props.dashboard_id} /> : <SecondTab dashboard_id={props.dashboard_id} />}
      </div>
    </div>
  );
};
export default Tabs;